export default "__VITE_ASSET__Cw0WGiB0__"